import { render } from "./ButtonBlock.vue?vue&type=template&id=6ea96827&scoped=true"
import script from "./ButtonBlock.vue?vue&type=script&lang=js"
export * from "./ButtonBlock.vue?vue&type=script&lang=js"

import "./ButtonBlock.vue?vue&type=style&index=0&id=6ea96827&lang=scss&scoped=true"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea96827"]])

export default __exports__